import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

export const GroupSelector = ({ values, handleChange, groups, width = 300 }) => {
    return (
        <FormControl sx={{ minWidth: width }}>
            <InputLabel id="group-label">{t('users.addToGroup')}</InputLabel>
            <Select
                labelId="group-label"
                id="group-selector"
                name="groupsToAssign"
                multiple
                value={values.groupsToAssign}
                onChange={handleChange}
                renderValue={(selected) =>
                    groups
                        .filter((g) => selected.includes(g.uuid))
                        .map((g) => g.name)
                        .join(', ')
                }
            >
                {groups.map((group) => (
                    <MenuItem key={group.uuid} value={group.uuid}>
                        {group.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

GroupSelector.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    groups: PropTypes.array.isRequired,
    width: PropTypes.number
};
